import { AxiosResponse } from 'axios';
import { call, delay, put, takeLatest } from 'redux-saga/effects';
import {
  POST_GET_ALL_SERIES_REQUEST,
  POST_UNRESERVE_MARKING_CODE_REQUEST,
  POST_GET_SERIES_DETAILED_REQUEST,
} from './constants';
import {
  postGetAllSeriesRequest,
  postGetAllSeriesSuccess,
  postGetAllSeriesError,
  postUnreserveMarkingCodeRequest,
  postUnreserveMarkingCodeSuccess,
  postUnreserveMarkingCodeError,
  postGetSeriesDetailedRequest,
  postGetSeriesDetailedSuccess,
  postGetSeriesDetailedError,
} from './actions';
import { Series } from '../../../../entities/Series/service';
import { uniqueId } from 'lodash';

function* postGetAllSeriesRequestSaga(action: ReturnType<typeof postGetAllSeriesRequest>) {
  try {
    const response: AxiosResponse = yield call(Series.getSeries, action.payload);
    const res = response.data.ResponseBody;
    yield put(
      postGetAllSeriesSuccess(
        res.map((element: any) => ({
          ...element,
          id: uniqueId(),
        })),
      ),
    );
  } catch (e: any) {
    const error = e.toJSON();
    yield put(postGetAllSeriesError(error));
  }
}

function* postUnreserveMarkingCodeRequestSaga(action: ReturnType<typeof postUnreserveMarkingCodeRequest>) {
  try {
    const response: AxiosResponse = yield call(Series.unreserveMarkinkCode, action.payload.params);
    const res = response.data.UserText;
    if (res) {
      yield put(postUnreserveMarkingCodeSuccess(res));
      yield put(postGetSeriesDetailedRequest(action.payload.seriesDetailedParams));
      yield delay(3000);
      yield put(postUnreserveMarkingCodeSuccess(null));
    } else {
      yield put(postUnreserveMarkingCodeSuccess(null));
      yield put(postGetSeriesDetailedRequest(action.payload.seriesDetailedParams));
    }
  } catch (e: any) {
    const error = e.toJSON();
    yield put(postUnreserveMarkingCodeError(error));
  }
}

function* postGetSeriesDetailedRequestSaga(action: ReturnType<typeof postGetSeriesDetailedRequest>) {
  try {
    const response: AxiosResponse = yield call(Series.detailedSeries, action.payload);
    const res = response.data.ResponseBody;
    yield put(postGetSeriesDetailedSuccess(res));
  } catch (e: any) {
    const error = e.toJSON();
    yield put(postGetSeriesDetailedError(error));
  }
}

export function* SeriesSagaWatcher() {
  yield takeLatest(POST_GET_ALL_SERIES_REQUEST, postGetAllSeriesRequestSaga);
  yield takeLatest(POST_UNRESERVE_MARKING_CODE_REQUEST, postUnreserveMarkingCodeRequestSaga);
  yield takeLatest(POST_GET_SERIES_DETAILED_REQUEST, postGetSeriesDetailedRequestSaga);
}
